import { ArrowLeft, Calendar, X } from "lucide-react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as api from "../api/api";
import "./TeamPage.css";

const TeamPage = () => {
  const { locationSlug } = useParams();
  const navigate = useNavigate();
  const [selectedMember, setSelectedMember] = React.useState(null);

  const [location, setLocation] = React.useState(null);
  const [team, setTeam] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const locs = await api.getLocations();
        const found = locs.find((l) => l.slug === locationSlug);
        if (mounted && found) setLocation(found);
      } catch (err) {
        console.warn("Failed to fetch locations, using mock", err);
      }

      try {
        const res = await api.getTeam(locationSlug);
        // accept empty arrays (res may be [])
        if (mounted && typeof res !== "undefined") setTeam(res);
      } catch (err) {
        console.warn("Failed to fetch team, using mock", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [locationSlug]);

  if (!location) {
    return <div>Location not found</div>;
  }

  return (
    <div className="team-page">
      {/* Navigation Header */}
      <div className="page-header">
        <div className="container">
          <button
            className="back-btn"
            onClick={() => navigate(`/${locationSlug}`)}
          >
            <ArrowLeft size={20} /> Retour
          </button>
          <h1 className="heading-lg">Notre Équipe</h1>
          <p
            className="body-lg"
            style={{ color: "var(--text-secondary)", marginTop: "1rem" }}
          >
            Rencontrez nos kinésithérapeutes expérimentés
          </p>
        </div>
      </div>

      {/* Team Grid */}
      <section className="section">
        <div className="container">
          <div className="team-grid">
            {team.map((member) => (
              <div
                key={member.id}
                className="team-member-card"
                onClick={() => setSelectedMember(member)}
              >
                <div className="member-image-container">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="member-image"
                  />
                </div>
                <div className="member-info">
                  <h3 className="heading-sm">{member.name}</h3>
                  <p className="member-role">{member.role}</p>
                  <div className="member-specialties">
                    {member.specialties.slice(0, 2).map((specialty, idx) => (
                      <span key={idx} className="specialty-tag">
                        {specialty}
                      </span>
                    ))}
                  </div>
                  <button
                    className="btn-secondary btn-small"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(member.doctolib, "_blank");
                    }}
                  >
                    <Calendar size={16} /> Prendre RDV
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Member Detail Modal */}
      {selectedMember && (
        <div className="modal-overlay" onClick={() => setSelectedMember(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setSelectedMember(null)}
            >
              <X size={24} />
            </button>
            <div className="modal-body">
              <div className="modal-image-container">
                <img src={selectedMember.photo} alt={selectedMember.name} />
              </div>
              <div className="modal-info">
                <h2 className="heading-md">{selectedMember.name}</h2>
                <p className="modal-role">{selectedMember.role}</p>
                <p
                  className="body-md"
                  style={{ marginTop: "1.5rem", lineHeight: "1.8" }}
                >
                  {selectedMember.bio}
                </p>
                <div className="modal-specialties">
                  <h4 className="heading-sm" style={{ marginBottom: "1rem" }}>
                    Spécialités
                  </h4>
                  <div className="specialties-list">
                    {selectedMember.specialties.map((specialty, idx) => (
                      <span key={idx} className="specialty-tag-large">
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>
                <a
                  href={selectedMember.doctolib}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                  style={{ marginTop: "2rem" }}
                >
                  <Calendar size={18} /> Prendre rendez-vous
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamPage;
